import * as React from "react";
const SvgFiRrBabyCarriage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-baby-carriage_svg__a)">
      <path
        fill="#062147"
        d="M15 0a1.96 1.96 0 0 0-2 2v7H5.468L4.229 7.512C3.48 6.46.292 4.933 0 7a1 1 0 0 0 1 1 2.2 2.2 0 0 1 1.692.792L4 10.362V11a5.006 5.006 0 0 0 5 5h2.865l-2.6 3.12a2.5 2.5 0 1 0 1.5 1.323L14 16.563l3.234 3.88a2.5 2.5 0 1 0 1.5-1.323L16.135 16H19a5.005 5.005 0 0 0 5-5v-1c0-9.886-8.91-10-9-10m6.961 9H15V2a7.083 7.083 0 0 1 6.961 7M19 14H9a3 3 0 0 1-3-3h16a3 3 0 0 1-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-baby-carriage_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBabyCarriage;
